document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav toggle ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var navMobile = document.querySelector('[data-nav-mobile]');
  if (menuToggle && navMobile) {
    menuToggle.addEventListener('click', function () {
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      navMobile.classList.toggle('is-open');
    });
  }

  /* ---------- Cart drawer open/close ---------- */
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawer = document.getElementById('CartDrawer');
  var cartCloseEls = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    refreshCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  cartCloseEls.forEach(function (el) { el.addEventListener('click', closeCart); });

  /* ---------- AJAX add-to-cart ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = document.getElementById('AddToCart');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          openCart();
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        });
    });
  }

  /* ---------- Cart drawer content refresh ---------- */
  function refreshCartDrawer() {
    var body = document.getElementById('CartDrawerBody');
    var subtotalEl = document.getElementById('CartDrawerSubtotal');
    var countEls = document.querySelectorAll('[data-cart-count]');
    if (!body) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
          return;
        }

        var html = '';
        cart.items.forEach(function (item) {
          html += '' +
            '<div class="cart-drawer__item">' +
              '<img src="' + item.image + '&width=160" alt="' + escapeHtml(item.product_title) + '">' +
              '<div class="cart-drawer__item-info">' +
                '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
                (item.variant_title ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
                '<p class="cart-drawer__item-qty">Qty ' + item.quantity + '</p>' +
              '</div>' +
              '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
            '</div>';
        });
        body.innerHTML = html;
      })
      .catch(function (err) { console.error('Cart fetch failed', err); });
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---------- Product gallery thumbnails ---------- */
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImage = document.getElementById('ProductMainImage');
  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Newsletter form (theme section, non-checkout) ---------- */
  var newsletterForm = document.querySelector('[data-newsletter-form]');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function () {
      var btn = newsletterForm.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Joining…'; }
    });
  }

  /* Initial cart count on load */
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function () {});
});
